import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'

const loginButton = document.getElementById('login-button')!

const params = new URLSearchParams(window.location.search)

const isLogoutPage = (): boolean => {
    return params.get('logout') === 'true'
}

const redirectPath = params.get('redirectPath') || '/index.html'

const signInIfNotAlreadySignedIn = async () => {
    const config = JSON.parse(process.env.AUTH_CONFIG)
    const app = initializeApp(config)
    const auth = getAuth(app)

    let user = auth.currentUser

    if (user === null) {
        await signInWithPopup(auth, new GoogleAuthProvider())
    }

    user = auth.currentUser
    if (!user) {
        alert('Authentication failed, please try again.')
        return
    }

    const token = await user.getIdToken()
    document.cookie = `__session=${token};`

    console.log('redirectPath', redirectPath)

    if (isLogoutPage()) {
        window.location.assign(redirectPath)
    } else {
        window.location.reload()
    }
}

loginButton.onclick = () => {
    console.log('login button clicked')
    signInIfNotAlreadySignedIn()
}

if (!isLogoutPage()) {
    signInIfNotAlreadySignedIn()
}
